export default __webpack_public_path__ + "static/s06-024c274bdc844b58643ac929ab91294a.png";